import classNames from 'classnames';
import React, { FC } from 'react';
import ReactCalendar from 'react-calendar';

import { IcLeftIcon, IcRightIcon } from '@gem/icons';

import styles from './Calendar.styles.m.css';

interface ICalendarProps {
  className?: string;
  value?: Date | Date[];
  maxDate?: Date;
  minDate?: Date;
  onChange: (date: Date) => void;
  locale?: string;
}

export const Calendar: FC<ICalendarProps> = ({
  className,
  value,
  maxDate,
  minDate,
  onChange,
  locale,
}) => {
  return (
    <ReactCalendar
      className={classNames(styles.calendar, className)}
      defaultValue={value}
      maxDate={maxDate}
      minDate={minDate}
      nextLabel={<IcRightIcon />}
      next2Label={null}
      prevLabel={<IcLeftIcon />}
      prev2Label={null}
      view="month"
      onChange={onChange}
      locale={locale}
    />
  );
};
